import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = {
  key: 0,
  class: "col-4"
}
const _hoisted_4 = {
  key: 1,
  class: "col-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.imagePositioningInContainer'),
        enabled: _ctx.enabled,
        name: _ctx.name,
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.localDto.object_fit_code,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.object_fit_code) = $event)),
                  _ctx.onObjectFitChanged
                ],
                options: _ctx.enumObjectFit,
                name: `${_ctx.name} ${_ctx.$t('cms.imageObjectFit')}`,
                label: _ctx.$t('cms.imageObjectFit'),
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
            ]),
            (_ctx.showPosition)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.localDto.position_horizontal_code,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.position_horizontal_code) = $event)),
                      _ctx.emitModelChanged
                    ],
                    options: _ctx.enumPositionHorizontal,
                    name: `${_ctx.name} ${_ctx.$t('cms.imagePositionHorizontal')}`,
                    label: _ctx.$t('cms.imagePositionHorizontal'),
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showPosition)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_InputSelect, {
                    modelValue: _ctx.localDto.position_vertical_code,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.position_vertical_code) = $event)),
                      _ctx.emitModelChanged
                    ],
                    options: _ctx.enumPositionVertical,
                    name: `${_ctx.name} ${_ctx.$t('cms.imagePositionVertical')}`,
                    label: _ctx.$t('cms.imagePositionVertical'),
                    selectText: _ctx.$t('selectText'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}